<template>
  <div id="viewIdle1" style="padding-bottom:30px" v-if="data" class="container">
    <div class="viewIdle_box">
      <div class="box" v-if="data">
        <el-row>
          <el-col :span="7">
            <el-image
              style="width:300px;height:300px"
              class="cover"
              :src=" serve + data.results.images"
              fit="cover"
            ></el-image>
          </el-col>
          <el-col :span="13">
            <div class="t1 lv1Text">{{data.results.title}}</div>
            <div class="b1 lv3Text" v-if="login_show === '0'">
              <div class="t2">
                品牌:
                <span>{{data.results.brand}}</span>
              </div>
              <div>
                货号:
                <span>{{data.results.item_no}}</span>
              </div>
              <div class="clearfix">
                <img
                  style="width:26px;height:26px;   float:left; border-radius: 50%;"
                  :src=" data.seller.headImg"
                  alt
                />
                <span style=" float:left;line-height:26px">&nbsp; {{data.seller.nickname}}</span>
              </div>
              <div>
                联系方式:
                <span>{{data.results.link}}</span>
              </div>
            </div>
            <div class="b2 lv3Text" v-if="login_show=== '1'">
              <div class="t2">
                出售价格 :
                <span style="font-size:16px;color:#E2211C">&yen;{{data.results.selling_price}}</span>
              </div>
              <div class="t2">
                品牌:
                <span>{{data.results.brand}}</span>
              </div>
              <div>
                货号:
                <span>{{data.results.item_no}}</span>
                购买日期 :
                <span>{{by_time}}</span>
              </div>
              <div class="clearfix">
                <img
                  style="width:26px;height:26px;   float:left; border-radius: 50%;"
                  :src=" data.seller.headImg"
                  alt
                />
                <span style=" float:left;line-height:26px">&nbsp; {{data.seller.nickname}}</span>

                <span style=" float:left;line-height:26px">&nbsp; 联系方式 :</span>
                <span style=" float:left;line-height:26px">&nbsp; {{data.results.link}}</span>
              </div>
              <div>
                保质期 :
                <span>{{ex_time}}</span>
              </div>
              <div>
                购买来源 :
                <span>{{data.results.buy_source}}</span>
              </div>
            </div>
            <div class="d1 clearfix">
              <div class="idleHome_right_seach_ipt">{{'https://www.bioflin.com/#' + $route.fullPath}}</div>

              <el-button
                type="info"
                v-clipboard:copy="  'https://www.bioflin.com/#' + $route.fullPath"
                v-clipboard:success="onCopy"
                style="border-radius: 0;float: left;background:#4F9CDC;border-color:#4F9CDC"
              >复制链接</el-button>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="margin: 60px  20px">
              <div style="border:1px solid rgba(221, 221, 221, 1);">
                <qrcode-vue
                  style="padding:5px 5px"
                  :value="'https://www.bioflin.com/#'+ $route.fullPath"
                  :size="140"
                  level="H"
                ></qrcode-vue>
              </div>
              <div style="text-align:center;padding-top:10px">扫码分享商品</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="box2">
        <el-row :gutter="30">
          <el-col :span="18">
            <div class="col">
              <div class="lv1Text" style="font-size:20px;text-align:center;padding-top:40px">商品介绍</div>
              <div
                style="padding:20px;word-wrap:break-word;border:1px; "
                v-html="data.results.info"
              ></div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="share_right">
              <div class="share_right_tit">其他资源</div>
              <div
                align="center"
                style="background:#fff;margin-bottom:20px"
                v-for="(item,index) of top4"
                :key="index"
                class="share_right_list"
              >
                <router-link :to="'share_details?id='+item.id">
                  <el-image
                    class="cover2"
                    style="width: 240px; height: 160px;padding-top:20px;"
                    :src="serve + '/' +_.split(item.images, ';', 1)"
                    fit="cover"
                  ></el-image>
                </router-link>
                <div class="lv1Text d2">
                  <router-link :to="'share_details?id='+item.id">{{item.title}}</router-link>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      login_show: null,
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: this.$route.query.id,
      data: null,
      top4: {}
    };
  },
  // watch: {
  //   $route: "initData"
  // },
  created() {
    // this.$store.state.user_location = "闲置交换";
    // this.$store.state.user_location2 = "商品详情";
    this.initData();
  },
  activated() {
    this.axios
      .get( this.serve + "/isLogin", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token"),
        }
      })
      .then(res => {
        this.login_show = res.data.data
      });
  },
  methods: {
    onCopy() {
      this.success("链接已复制,快去分享吧！");
    },
    success(msg) {
      this.$message.success({
        type: "success",
        message: msg,
        offset: 150
      });
    },
    // buy() {
    //   var data = this.data;
    //   this.$router.push({
    //     path: "/user/createidleorder",
    //     query: { data: JSON.stringify(data.results) }
    //   });
    // },
    initData() {
      this.axios
        .get(this.serve + "/exchange_detail", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          this.data = res.data.data;
        });
      this.loadTop4();
    },
    loadTop4() {
      this.top4 = {};
      this.axios
        .get(this.serve + "/four_exchange", {
          params: {
            id: this.id
          }
        })
        .then(res => {
          this.top4 = res.data.data;
        });
    }
  },
  // .slice().indexOf(' ')
  computed: {
    by_time() {
      return new Date(parseInt(this.data.results.buy_time) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ")
        .slice(
          0,
          new Date(parseInt(this.data.results.buy_time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ")
            .indexOf(" ")
        );
    },
    ex_time() {
      return new Date(parseInt(this.data.results.create_date) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ")
        .slice(
          0,
          new Date(parseInt(this.data.results.create_date) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ")
            .indexOf(" ")
        );
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#viewIdle1 {
  width: 100%;
  border-top: 2px solid #e2211c;
  table {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }
  .viewIdle_box {
    width: 1200px;
    margin: 20px auto 0 auto;
    .box {
      height: 340px;
      background-color: #fff;
      padding: 40px 0 0 40px;
    }
  }
  .d2:hover a {
    color: #e2211c;
  }
  .d2 {
    padding: 10px 0 30px 0;
  }
  .d3 {
    padding: 2px 0 10px 0;
  }
  .top4-item {
    background: #fff;
    margin-bottom: 20px;
  }
  .c1 {
    margin-bottom: 20px;
  }
  .name {
    line-height: 50px;
  }
  .d1 {
    margin-top: 20px;
    width: 100%;
    .idleHome_right_seach_ipt {
      float: left;
      width: 520px;
      height: 40px;
      background: rgba(221, 221, 221, 1);
      border-radius: 2px 0px 0px 2px;
      line-height: 40px;
      padding-left: 10px;
    }
  }
  .avatar {
    border-radius: 50px;
    overflow: hidden;
  }
  .box2 {
    margin-top: 20px;
    .share_right {
      width: 100%;
      .share_right_tit {
        font-size: 14px;
        font-family: "Microsoft YaHei";
        text-align: center;
        padding: 40px 0 20px 0;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        background: #fff;
        .share_right_list {
          width: 100%;
          height: 234px;
          background: orange;
        }
      }
    }
    .col {
      background-color: #fff;
      width: 100%;
    }
  }
  .t1 {
    font-size: 30px;
    margin-bottom: 30px;

    font-size: 24px;
    color: rgba(51, 51, 51, 1);
  }
  .b1 {
    font-size: 14px;
    height: 166px;
    background: rgba(221, 221, 221, 1);
    color: #333333;
    div {
      padding: 10px 0 10px 20px;
    }
  }
  .b2 {
    font-size: 14px;
    height: 196px;
    background: rgba(221, 221, 221, 1);
    color: #333333;
    div {
      padding: 12px 0 0px 20px;
    }
  }
}
</style>

